module.exports = __webpack_public_path__ + "img/beri-dari.243c7d4b.svg";